/** global: localStorage */
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import omit from 'lodash/omit';
import { EVENT_TYPE_REGIONAL, EVENT_TYPE_STATEWIDE, EVENT_TYPE_WEBINAR, STATE_ABBREVIATIONS } from 'utils/consts';
import { getToken } from './auth';
import React from 'react';
import get from 'lodash/get';

const WORK_SECTOR_TOKEN = 'c@xy-infinitec-selcted-work-sector';
const ENGAGE_TAB_TOKEN = 'c@xy-infinitec-selcted-engage-tab';

export const ATTACHMENT_TYPE_MODULE = 'module';
export const ATTACHMENT_TYPE_EVENT = 'event';
export const ATTACHMENT_TYPE_FORUM = 'forum';

export const formatDate = (date, format = 'L') => {
  return moment(date).format(format);
};

export const formatDateCentralTime = (date, format = 'L') => {
  return momentTimezone(date)
    .tz('America/Chicago')
    .format(format);
};

export const formatPercent = value => {
  return value * 100;
};

export const formatSecondsToMinutes = value => {
  return (value / 60).toFixed(0);
};

export const formatModuleRunningTime = seconds => {
  const minutes = Math.floor((seconds % 3600) / 60);
  const hours = Math.floor(seconds / 3600);

  return (hours ? `${hours} hr(s) ` : '') + (minutes ? `${minutes} min(s)` : '');
};

// this function may need to be optimized
export const omitDeep = (obj, removeKey) => {
  let newObj = omit(obj, removeKey);
  for (const key in obj) {
    if (Array.isArray(newObj[key])) {
      newObj[key] = newObj[key].map(item => omitDeep(item, removeKey));
    } else if (newObj[key] && typeof newObj[key] === 'object') {
      newObj[key] = omitDeep(newObj[key], removeKey);
    }
  }
  return newObj;
};

export const convertSecondsToTimeStamp = playingTimeInSeconds => {
  const seconds = Math.floor((playingTimeInSeconds % 3600) % 60)
    .toString()
    .padStart(2, '0');
  const minutes = Math.floor((playingTimeInSeconds % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const hours = Math.floor(playingTimeInSeconds / 3600);

  return (hours ? `${hours}:` : '') + (minutes ? `${minutes}:` : hours ? `00:` : '') + (seconds ? `${seconds}` : '00');
};

export const abbreviateStateName = state => {
  try {
    return STATE_ABBREVIATIONS[state];
  } catch (e) {
    return state;
  }
};

export const getWorkSector = () => localStorage.getItem(WORK_SECTOR_TOKEN);

export const setWorkSector = sectorId => localStorage.setItem(WORK_SECTOR_TOKEN, sectorId);

export const getEngageTab = () => localStorage.getItem(ENGAGE_TAB_TOKEN);

export const setEngageTab = engageTab => localStorage.setItem(ENGAGE_TAB_TOKEN, engageTab);

export const processAttachmentsToLinks = (attachments, attachmentType, id) => {
  let processedAttachments = [];

  for (const attachment of attachments) {
    processedAttachments.push({
      key: attachment.document.id,
      element: (
        <a
          href={`${process.env.REACT_APP_API_URL}/api/attachment/${attachmentType}/${id}/document/${
            attachment.document.id
          }?bearerToken=${getToken()}`}
          rel='noopener noreferrer'
          target='_blank'
        >
          {attachment.linkText}
        </a>
      ),
    });
  }

  return processedAttachments;
};

export const prepareDataForLearningCampaignSubmit = values => {
  const uploadedUsers = get(values, 'uploadedUsers', []);

  // This is a quick change to the value data to replace the user and certificate object with the ID of the object.
  const formattedUploadedUserList = uploadedUsers.map(function(uploadedUser) {
    return {
      ...uploadedUser,
      user: uploadedUser.user ? uploadedUser.user.id : null,
      certificate: get(uploadedUser, 'campaignProgress.certificate.id'),
    };
  });

  return omitDeep(
    {
      ...values,
      copiedTemplateId: values.infLearningTemplate,
      learningPath: typeof values.learningPath === 'string' ? values.learningPath : get(values, 'learningPath[0].name'),
      includeDiscussionForum: values.includeDiscussionForum === 'true',
      modules: values.modules.map(m => ({ module: m.module.id, includeQuiz: m.includeQuiz })),
      uploadedUsers: formattedUploadedUserList,
      certificateType: values.campaignLevelCertificatesEnabled ? values.certificateType : undefined,
      forumNotificationsTo: values.forumNotificationsTo ? values.forumNotificationsTo[0].name : null,
      startDate: moment
        .utc(values.startDate)
        .startOf('day')
        .format(),
      endDate: moment
        .utc(values.endDate)
        .endOf('day')
        .format(),
    },
    ['__typename', 'progress', 'campaignProgress']
  );
};

export const processEventType = item => {
  switch (item.type) {
    case EVENT_TYPE_STATEWIDE:
      const stateText = get(item, 'state.name') ? ` - ${abbreviateStateName(get(item, 'state.name'))}` : '';
      return `Statewide ${stateText}`;
    case EVENT_TYPE_REGIONAL:
      const regionText = get(item, 'region.name') ? ` - ${get(item, 'region.name')}` : '';
      return `Regional ${regionText}`;
    case EVENT_TYPE_WEBINAR:
      return `Webinar`;
    default:
      return item.type;
  }
};
